<template>
  <div class="d-flex">
    <!-- content head -->
    <div class="w-300px mr-5">
      <h3 class="mb-10px">Image</h3>
      <div class="h4">
        至少需要填寫一組 <br />
        可添加欄位做內容填充
      </div>
    </div>
    <div class="flex-grow-1">
      <!-- content body -->
      <div class="block mb-5" v-for="(item, i) in content" :key="i">
        <!-- content -->
        <div
          class="form-item py-5 d-flex align-center justify-lg-space-between"
        >
          <h4>Image</h4>
          <button
            v-if="i > 0"
            class="btn btn-danger square w-32px h-32px"
            @click="deleteItem(i)"
          >
            <v-icon color="white">delete</v-icon>
          </button>
        </div>
        <!-- Image -->
        <div class="form-item d-flex px-5 py-5">
          <div class="w-180px">
            <h4 class="mb-10px">Image</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：999px * 999px <br />
              檔案大小限制：&lt; 1 MB
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.image"
              dir="ir"></ImgUploader>
          </div>
        </div>
      </div>
      <!-- add Content Section -->
      <div class="mt-5 mb-9">
        <button class="btn btn-outlined w-100 justify-start" @click="$emit('addItem')">
          <v-icon class="primary--text mr-2">add_circle</v-icon>
          <span>添加Content</span>
        </button>
      </div>
      <div class="page-actions">
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="$emit('cancelHandler')">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" @click="$emit('saveHandler')">
          <span>儲存</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  props: {
    content: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ImgUploader,
  },
  methods: {
    deleteItem(index) {
      this.content.splice(index, 1);
    },
  },
};
</script>

<style></style>
